import { createAction } from 'redux-act';
import { toastr } from 'react-redux-toastr';

// import { getSignalStatusWithLastRecord } from 'utils/hdrainHelper';

import { parseArrayToDict } from 'utils';
import {
  getHexSerialNumber,
  getLastStatusFromLastData,
} from 'utils/hdrainHelper';
import { fillData, filterDataByEpoch } from 'utils/dataHelper';
import {
  getStationData,
  getLastStationsData,
  getInstallationData,
  getRbv3Station,
} from '../api/hdrainClient';
// import {
// ACTIONS_NAMES_DICT as STATIONS_ACTIONS_NAMES_DICT,
// STATIONS_ACTIONS,
// } from './stations';

const ENTITIES = 'STATIONS_DATA';

export const ACTIONS_NAMES_DICT = {
  FETCH_DATA_INIT: `${ENTITIES}_FETCH_DATA_INIT`,
  FETCH_DATA_SUCCESS: `${ENTITIES}_FETCH_DATA_SUCCESS`,
  FETCH_DATA_FAIL: `${ENTITIES}_FETCH_DATA_FAIL`,

  FETCH_LAST_DATA_INIT: `${ENTITIES}_FETCH_LAST_DATA_INIT`,
  FETCH_LAST_DATA_SUCCESS: `${ENTITIES}_FETCH_LAST_DATA_SUCCESS`,
  FETCH_LAST_DATA_FAIL: `${ENTITIES}_FETCH_LAST_DATA_FAIL`,

  FETCH_INSTALLATION_DATA_INIT: `${ENTITIES}_FETCH_INSTALLATION_DATA_INIT`,
  FETCH_INSTALLATION_DATA_SUCCESS: `${ENTITIES}_FETCH_INSTALLATION_DATA_SUCCESS`,
  FETCH_INSTALLATION_DATA_FAIL: `${ENTITIES}_FETCH_INSTALLATION_DATA_FAIL`,

  DARKENING_START: 'DARKENING_START',
  DARKENING_STOP: 'DARKENING_STOP',
  DARKENING_FAIL: 'DARKENING_FAIL',
  DARKENING_RESET: 'DARKENING_RESET',

  PROCESS_DARKENING_SNR_INIT: 'PROCESS_DARKENING_SNR_INIT',
  PROCESS_DARKENING_SNR_SUCCESS: 'PROCESS_DARKENING_SNR_SUCCESS',
  PROCESS_DARKENING_SNR_FAIL: 'PROCESS_DARKENING_SNR_FAIL',

  CLEAN_UP: `${ENTITIES}_CLEAN_UP`,
  CLEAR_DATA_LOGOUT: `${ENTITIES}_CLEAR_DATA_LOGOUT`,
};

const ACTIONS_DICT = Object.keys(ACTIONS_NAMES_DICT).reduce(
  (accumulator, currentKey) => {
    const currentValue = ACTIONS_NAMES_DICT[currentKey];
    accumulator[currentKey] = createAction(currentValue);
    return accumulator;
  },
  {}
);

export const STATIONS_DATA_ACTIONS = Object.keys(ACTIONS_NAMES_DICT).reduce(
  (accumulator, currentKey) => {
    const key = ACTIONS_NAMES_DICT[currentKey];
    const value = ACTIONS_DICT[currentKey];
    accumulator[key] = value;
    return accumulator;
  },
  {}
);

export const fetchEntities = (id) => {
  return async (dispatch) => {
    dispatch(ACTIONS_DICT.FETCH_DATA_INIT());

    let entities;
    const filledEntities = {};
    try {
      entities = await getStationData(id);

      // Fill data with null values
      // If there are not continuous in time
      const dataKeys = [
        { type: 'signal' },
        { type: 'status', timeDiff: 2 * 60 * 1000 },
        { type: 'locales' },
      ];

      const hexStationId = getHexSerialNumber(id);
      dataKeys.forEach((dataKey) => {
        if (entities && entities[dataKey.type]) {
          const { timeDiff } = dataKey;
          filledEntities[dataKey.type] = {};
          filledEntities[dataKey.type][hexStationId] = fillData(
            entities[dataKey.type][hexStationId],
            {
              timeDiff,
            }
          );
        }
      });
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      toastr.error('Error fetching data', error);
      return dispatch(ACTIONS_DICT.FETCH_DATA_FAIL({ error }));
    }

    return dispatch(
      ACTIONS_DICT.FETCH_DATA_SUCCESS({
        data: filledEntities,
      })
    );
  };
};

// Function to fetch Rbv3
const getLastStationsDataV3 = async (_serialNumbersV3) => {
  let dataPromisesV3 = { signal: null, status: null, locales: null };
  dataPromisesV3 = await Promise.all(
    _serialNumbersV3.map((rbv3SerialNumber) => {
      return getRbv3Station(rbv3SerialNumber).then((unsortedResultRbv3) => {
        let sortedResultRbv3 = {};
        sortedResultRbv3 = {
          signal: {
            [rbv3SerialNumber]: {
              NLH: {
                NLH: -35,
                epoch: unsortedResultRbv3.ltTimestamp,
                health: 1,
              },
            },
          },
          status: {
            [rbv3SerialNumber]: {
              vbat: {
                vbat: unsortedResultRbv3.vbat,
                epoch: unsortedResultRbv3.ltTimestamp,
                health: 0.5,
              },
            },
          },
        };
        dataPromisesV3.signal = {
          ...dataPromisesV3.signal,
          ...sortedResultRbv3.signal,
        };
        dataPromisesV3.status = {
          ...dataPromisesV3.status,
          ...sortedResultRbv3.status,
        };
        return dataPromisesV3;
      });
    })
  );
  return dataPromisesV3[0];
};

export const fetchLastEntities = (serialNumbers = []) => {
  const _serialNumbers = serialNumbers.filter((serialNumber) => {
    if (serialNumber) {
      return true;
    }
    return false;
  });

  const _serialNumbersV2 = [];
  const _serialNumbersV3 = [];
  _serialNumbers.map((serialNumber) => {
    if (serialNumber.length === 8) {
      _serialNumbersV3.push(serialNumber);
    } else {
      _serialNumbersV2.push(serialNumber);
    }
    return true;
  });

  return async (dispatch, getState) => {
    dispatch(ACTIONS_DICT.FETCH_LAST_DATA_INIT());
    let entities;
    const allLastStatus = {};

    const arrayOfChunks = [];
    // due to time out, we need to divide our array
    const chunkV2 = 100;
    for (let i = 0; i < _serialNumbersV2.length; i += chunkV2) {
      const temparray = _serialNumbersV2.slice(i, i + chunkV2);
      arrayOfChunks.push(temparray);
    }

    const promisesV2 = arrayOfChunks.map((chunks) => {
      return getLastStationsData(chunks);
    });
    const promisesV3 = getLastStationsDataV3(_serialNumbersV3);
    promisesV2.push(promisesV3);

    return Promise.all(promisesV2)
      .then((results) => {
        entities = {};
        results.forEach((result) => {
          if (result && result.signal) {
            entities.signal = { ...entities.signal, ...result.signal };
          }
          if (result && result.status) {
            entities.status = { ...entities.status, ...result.status };
          }
          if (result && result.locales) {
            entities.locales = { ...entities.locales, ...result.locales };
          }

          const stations = getState().stations.data;
          // Update last status for stations

          // Get dictionary based on serial number
          const stationsDict = parseArrayToDict(stations, 'serialNumber');

          // Transform this dict with hexadecimal serial number
          const hexStationsDict = {};
          _serialNumbers.forEach((stationId) => {
            const station = stationsDict[stationId];
            if (station) {
              const { serialNumber } = station;
              let hexSerialNumber = '';
              if (
                typeof serialNumber === 'string' &&
                serialNumber.startsWith('03')
              ) {
                hexSerialNumber = serialNumber; // Rbv3 -> n° de série type 03XXXXXX String
              } else {
                hexSerialNumber = getHexSerialNumber(serialNumber); // Rbv2 -> n° de série type XXX Number
              }
              hexStationsDict[hexSerialNumber] = station;
            }
          });

          // Loop over hex serial numbers
          // and update station with last status object.
          Object.keys(hexStationsDict).forEach((hexSerialNumber) => {
            const station = hexStationsDict[hexSerialNumber];
            const { id } = station;
            if (station && entities) {
              const lastStatus = getLastStatusFromLastData(
                entities,
                hexSerialNumber
              );
              allLastStatus[id] = lastStatus;
            }
          });
          return allLastStatus;
        });
      })
      .catch((error) => {
        console.log(error); // eslint-disable-line no-console
        toastr.error('Error fetching last data.', error);
        return dispatch(ACTIONS_DICT.FETCH_LAST_DATA_FAIL({ error }));
      })
      .then(() => {
        return dispatch(
          ACTIONS_DICT.FETCH_LAST_DATA_SUCCESS({
            lastData: entities,
            lastStatus: allLastStatus,
          })
        );
      });
  };
};

export const fetchInstallationEntities = (id) => {
  return async (dispatch) => {
    dispatch(ACTIONS_DICT.FETCH_INSTALLATION_DATA_INIT());

    let entities;
    try {
      entities = await getInstallationData(id);
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      toastr.error('Error fetching data', error);
      return dispatch(ACTIONS_DICT.FETCH_INSTALLATION_DATA_FAIL({ error }));
    }

    return dispatch(
      ACTIONS_DICT.FETCH_INSTALLATION_DATA_SUCCESS({
        data: entities,
      })
    );
  };
};
export const clearEntitiesDataLogout = () => {
  return (dispatch) => {
    dispatch(ACTIONS_DICT.CLEAR_DATA_LOGOUT());
  };
};

export const entitiesCleanUp = () => (dispatch) =>
  dispatch(ACTIONS_DICT.CLEAN_UP());

export const startDarkening = ({ darkeningStartedAt }) => {
  return (dispatch) => {
    dispatch(ACTIONS_DICT.DARKENING_START({ darkeningStartedAt }));
  };
};

export const stopDarkening = () => {
  return (dispatch) => {
    dispatch(ACTIONS_DICT.DARKENING_STOP());
  };
};

export const resetDarkening = () => {
  return (dispatch) => {
    dispatch(ACTIONS_DICT.DARKENING_RESET());
  };
};

export const processDarkeningSNR = (serialNumber, signalKey) => {
  return async (dispatch, getState) => {
    dispatch(ACTIONS_DICT.PROCESS_DARKENING_SNR_INIT());
    let entities;
    let darkeningSNR = null;
    try {
      entities = await getInstallationData(serialNumber);
      const hexSerialNumber = getHexSerialNumber(serialNumber);
      const {
        darkeningStartedAt,
        darkeningStoppedAt,
      } = getState().stationsData;

      const filteredSignalEntities = filterDataByEpoch(
        entities.signal[hexSerialNumber],
        darkeningStartedAt,
        darkeningStoppedAt
      );
      const signalValues = filteredSignalEntities.map((sample) => {
        return sample[signalKey];
      });

      if (signalValues && signalValues.length > 0) {
        const maxSignalValue = Math.max(...signalValues);
        const minSignalValue = Math.min(...signalValues);
        darkeningSNR = parseFloat((maxSignalValue - minSignalValue).toFixed(2));
      }
    } catch (error) {
      console.error(error); // eslint-disable-line no-console
      toastr.error('Error processDarkeningSNR', error);
      return dispatch(ACTIONS_DICT.PROCESS_DARKENING_SNR_FAIL({ error }));
    }
    return dispatch(
      ACTIONS_DICT.PROCESS_DARKENING_SNR_SUCCESS({
        darkeningSNR,
      })
    );
  };
};
